<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col
            :md="6"
            :sm="12"
          >
            <a-form-item label="事件编号">
              <a-input
                v-model="query.eventNo"
                placeholder="请输入事件编号"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="12"
          >
            <a-form-item label="事件类型">
              <a-select
                placeholder="请选择事件类型"
                v-model="query.eventType"
              >
                <a-select-option
                  v-for="item in ManagerList"
                  :key="item.dictValue"
                >
                  {{ item.dictValue }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="12"
          >
            <a-form-item label="上报人">
              <a-input
                v-model="query.reportPerson"
                placeholder="请输入上报人"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="12"
          >
            <a-form-item label="发生地点">
              <a-input
                v-model="query.address"
                placeholder="请输入发生地点"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="12"
            :sm="12"
          >
            <a-form-item label="上报时间">
              <a-range-picker
                v-model="Uploadtime"
                @change="onChanget"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col
            :md="12"
            :sm="24"
          >
            <span class="table-page-search-submitButtons">
              <a-button
                type="primary"
                @click="queryList"
              >查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="resetList"
              >重置</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="addOrUpdateHandle()"
                v-action:add
              >新增</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="exportHandle()"
                v-action:export
              >导出</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="PublishTask()"
              >发布任务</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="DispatchOrder()"
              >派发工单</a-button>
              <a-button
                type="danger"
                style="margin-left: 8px"
                @click="deleteSelectRow()"
                v-action:del
              >删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 3000 }"
      :row-selection="{
        selectedRowKeys: this.selectedRows,
        selectedRows: this.selectedRowsList,
        onChange: onSelectChange,
      }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span
        slot="action"
        slot-scope="text, record"
      >
        <!-- <a @click="editHandle(record.id)" v-action:edit>标记</a>
        <a-divider type="vertical" /> -->
        <a @click="details(record.id)">详情</a>
      </span>
      <span
        slot="handlingDuration"
        slot-scope="text"
        v-if="text !== null"
      >{{ text }}</span>
      <span
        slot="createTime"
        slot-scope="text"
      >{{ moment(text).format('YYYY-MM-DD') }}</span>
      <template
        slot="statusAction"
        slot-scope="text"
      >
        <a-tag
          color="#f5222d"
          v-if="text == 0"
        >未处理</a-tag>
        <a-tag
          color="rgb(50, 205, 50)"
          v-if="text == 1"
        >已处理</a-tag>
        <a-tag
          color="#f98303"
          v-if="text == 2"
        >处理中</a-tag>
      </template>
      <template
        slot="stateType"
        slot-scope="text, record"
      >
        <a-tag
          color="#52c41a"
          v-if="record.stateType == 1"
        >一般</a-tag>
        <a-tag
          color="#f98303"
          v-if="record.stateType == 2"
        >中等</a-tag>
        <a-tag
          color="#f5222d"
          v-if="record.stateType == 3"
        >紧急</a-tag>
      </template>
      <template
        slot="fileNamesAction"
        slot-scope="text"
      >
        <div style="width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
          {{ text[0].name }}
        </div>
      </template>
    </a-table>
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map
        ref="lonlatMaps"
        @handleMapOk="handleMapOk"
      ></lonlat-map>
    </a-modal>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button
          :disabled="isUpdate"
          type="primary"
          @click="handleOk"
        >确定</a-button>
      </template>
      <a-form-model
        class="log-form"
        :model="addOrUpdateForm"
        ref="addOrUpdateForm"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-row
          class="form-row"
          type="flex"
          justify="center"
          :gutter="4"
        >
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="事件名称"
              prop="eventName"
            >
              <a-input
                :disabled="isUpdate"
                placeholder="请输入"
                v-model="addOrUpdateForm.eventName"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="事件类型"
              prop="eventTypes"
            >
              <a-select
                :disabled="isUpdate"
                placeholder="请选择事件类型"
                v-model="addOrUpdateForm.eventTypes"
                mode="multiple"
              >
                <a-select-option
                  v-for="item in ManagerList"
                  :key="item.dictValue"
                >
                  {{ item.dictValue }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="片区选择"
              prop="zoneId"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 10 }"
            >
              <a-tree-select
                :tree-data="zoneTreeData"
                v-model="addOrUpdateForm.zoneId"
                style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :disabled="isUpdate"
                placeholder="请选择片区"
                allow-clear
                tree-default-expand-all
              ></a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="事件标记"
              prop="stateType"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
            >
              <a-radio-group
                :disabled="isUpdate"
                v-model="addOrUpdateForm.stateType"
                :options="options"
                @change="onChangeRadio"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="添加位置"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="locationInformation"
            >
              <a-button
                type="primary"
                @click="addAddress"
              >
                <span v-if="isUpdate">查看位置</span>
                <span v-else>添加位置</span>
              </a-button>
              <a-input
                :disabled="isUpdate"
                placeholder="请输入"
                v-model="addOrUpdateForm.locationInformation"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="地址"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="address"
            >
              <a-textarea
                :disabled="isUpdate"
                placeholder="请输入"
                v-model="addOrUpdateForm.address"
                :rows="2"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="上报人"
              prop="reportPerson"
            >
              <a-input
                :disabled="isUpdate"
                placeholder="请输入"
                v-model="addOrUpdateForm.reportPerson"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="联系电话"
              prop="phone"
            >
              <a-input
                :disabled="isUpdate"
                placeholder="请输入"
                v-model="addOrUpdateForm.phone"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="事件描述"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="eventDescription"
            >
              <a-textarea
                :disabled="isUpdate"
                placeholder="多行输入"
                v-model="addOrUpdateForm.eventDescription"
                :rows="4"
              />
            </a-form-model-item>
          </a-col>

          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="附件上传"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 10 }"
            >
              <a-upload-dragger
                :disabled="isUpdate"
                name="file"
                :multiple="true"
                :customRequest="customRequest"
                :showUploadList="false"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                  文件拖拽此处或
                  <a>点击上传</a>
                </p>
              </a-upload-dragger>
              <div class="fileDiv">
                <a-row style="margin-top: 20px">
                  <a-col :span="12">
                    <div class="fileDiv">
                      图片：
                      <ul>
                        <li
                          class="fileLi"
                          v-for="item in fileNamesimg"
                          :key="item.url"
                        >
                          <img
                            :src="item.url"
                            alt=""
                            style="width: 80px; height: 80px"
                            @click="clicimg(item.url)"
                          />
                        </li>
                      </ul>
                    </div>
                  </a-col>
                  <a-col :span="12">
                    <div class="fileDiv">
                      文件：
                      <ul>
                        <li
                          class="fileLi"
                          v-for="item in fileNamestex"
                          :key="item.url"
                        >
                          <div
                            class="uploadDiv"
                            @click="uploadFile(item)"
                          >
                            <a-icon
                              type="file-done"
                              style="cursor: pointer"
                            />
                            {{ item.name }}
                          </div>
                          <a-icon
                            type="delete"
                            style="float: right; cursor: pointer"
                            @click="deleteFile(item.url)"
                          />
                        </li>
                      </ul>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisibles"
      @ok="mapVisibles = false"
      @cancel="mapVisibles = false"
    >
      <lonlat-map
        ref="lonlatMaps"
        @handleMapOk="handleMapOk"
      ></lonlat-map>
    </a-modal>
    <task-modal ref="TaskModal"></task-modal>
    <order-modal
      ref="OrderModal"
      @handleOk="queryList"
    ></order-modal>
    <edit-modal
      ref="EditModal"
      @handleOk="queryList"
    ></edit-modal>
    <detail-modal ref="DetailModal"></detail-modal>
    <!-- 详情 -->
    <a-modal
      title="详情"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelh"
    >
      <a-row style="margin-top: 20px">
        <a-col :span="12">事件编号：{{ detail.eventNo }}</a-col>
        <a-col :span="12">事件名称：{{ detail.eventName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">事件类型：{{ detail.eventType }}</a-col>
        <a-col :span="12">片区：{{ detail.zoneName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">处理方式：{{ detail.processMode }}</a-col>
        <a-col :span="12">上报人：{{ detail.reportPerson }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">上报时间：
          <span v-if="detail.reportTime !== null">{{ moment(detail.reportTime).format('YYYY-MM-DD') }}</span>
        </a-col>
        <a-col :span="12">联系方式：{{ detail.phone }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">
          紧急状态：

          <a-tag
            color="#52c41a"
            v-if="detail.stateType == 1"
          >一般</a-tag>
          <a-tag
            color="#f98303"
            v-if="detail.stateType == 2"
          >中等</a-tag>
          <a-tag
            color="#f5222d"
            v-if="detail.stateType == 3"
          >紧急</a-tag>
        </a-col>
        <a-col :span="12">
          事件状态： <a-tag
            color="#f5222d"
            v-if="detail.status == 0"
          >未处理</a-tag>
          <a-tag
            color="rgb(50, 205, 50)"
            v-if="detail.status == 1"
          >已处理</a-tag>
          <a-tag
            color="#f98303"
            v-if="detail.status == 2"
          >处理中</a-tag>
        </a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">处理时长：{{ detail.handlingDuration }}</a-col>
        <a-col :span="12">
          地址：<span
            style="color: #0000ff"
            @click="addAddres"
          >{{ detail.address }}</span></a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">事件描述：{{ detail.eventDescription }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">
          <div class="fileDiv">
            图片：
            <ul>
              <li
                class="fileLi"
                v-for="item in fileNamesimg"
                :key="item.url"
              >
                <img
                  :src="item.url"
                  alt=""
                  style="width: 80px; height: 80px"
                  @click="clicimg(item.url)"
                />
              </li>
            </ul>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="fileDiv">
            文件：
            <ul>
              <li
                class="fileLi"
                v-for="item in fileNamestex"
                :key="item.url"
              >
                <div
                  class="uploadDiv"
                  @click="uploadFile(item)"
                >
                  <a-icon
                    type="file-done"
                    style="cursor: pointer"
                  />
                  {{ item.name }}
                </div>
                <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
              </li>
            </ul>
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal
      title="图片"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visibles"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelhlg"
    >
      <img
        :src="this.pumpUrlg"
        :alt="this.pumpUrlg"
        style="width: 100%; height: 100%"
      />
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import LonlatMap from './modules/lonlatMap.vue'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import TaskModal from './modules/TaskModal'
import OrderModal from './modules/OrderModal'
import EditModal from './modules/EditModal'
import DetailModal from './modules/DetailModal'
const options = [
  { label: '一般', value: 1 },
  { label: '中等', value: 2 },
  { label: '紧急', value: 3 }
]
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 60,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    }
  },
  {
    title: '事件编号',
    width: 150,
    dataIndex: 'eventNo'
  },
  {
    title: '片区',
    width: 150,
    dataIndex: 'zoneName'
  },
  {
    title: '事件名称',
    width: 150,
    dataIndex: 'eventName'
  },
  {
    title: '事件类型',
    width: 150,
    dataIndex: 'eventType'
  },
  {
    title: '上报人',
    width: 150,
    dataIndex: 'reportPerson'
  },
  {
    title: '联系电话',
    width: 150,
    dataIndex: 'phone'
  },
  {
    title: '上报时间',
    width: 150,
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '发生地点',
    width: 350,
    dataIndex: 'address'
  },
  {
    title: '紧急状态',
    width: 150,
    dataIndex: 'stateType',
    scopedSlots: { customRender: 'stateType' }
  },
  {
    title: '事件状态',
    width: 150,
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' }
  },
  {
    title: '处理方式',
    width: 150,
    dataIndex: 'processMode'
  },
  {
    title: '处理时长',
    width: 150,
    dataIndex: 'handlingDuration',
    scopedSlots: { customRender: 'handlingDuration' }
  },
  {
    title: '事件描述',
    width: 150,
    dataIndex: 'eventDescription'
  },
  {
    title: '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  components: {
    TaskModal,
    OrderModal,
    EditModal,
    DetailModal,
    LonlatMap
  },
  name: 'EventManagement',
  data () {
    return {
      options,
      visible: false,
      confirmLoading: false,
      mapVisible: false,
      currentId: '',
      visibles: false,
      mapVisibles: false,
      confirmLoading: false,
      pumpUrlg: '',
      queryUrl: '/pipe-network/tenant_events/page',
      deleteUrl: '/pipe-network/tenant_events',
      addOrUpdateUrl: '/pipe-network/tenant_events',
      queryOneUrl: '/pipe-network/tenant_events',
      exportDataUrl: 'pipe-network/tenant_events/export',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportFileName: '事件管理表.xlsx',
      query: {
        eventTypes: '',
        address: '',
        startTime: '',
        endTime: '',
        conductor: '',
        reportPerson: '',
        sysType: '巡检',
        eventNo: ''
      },
      Uploadtime: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      detail: {
        locationInformation: ''
      },
      addOrUpdateForm: {
        eventName: '',
        eventTypes: [],
        locationInformation: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        assistPerson: [],
        // accessorys: [],
        fileNames: [],
        stateType: 0,
        zoneId: '',
        sysType: '巡检'
      },
      uploadUrl: '/manager/file/resources/upload',
      ManagerList: [],
      eventTypeList: [],
      fileList: [],
      fileNamesimg: [],
      fileNamestex: [],
      zoneTreeData: [], // 分区数据选项
      isUpdate: false,
      onChangets: ''
    }
  },
  filters: {
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  computed: {
    rules () {
      return {
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'blur' }],
        eventTypes: [{ required: true, message: '请选择事件类型', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        reportPerson: [{ required: true, message: '请输入上报人', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号码!' }
        ],
        reportTime: [{ required: true, message: '请选择上报时间', trigger: 'change' }],
        eventDescription: [{ required: true, message: '请输入事件描述', trigger: 'blur' }],
        stateType: [{ required: true, message: '请选择事件标记', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getManagerList()
    this.getZoneData()
  },
  methods: {
    moment,
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            this.selectedRows = []
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.Uploadtime = []
      this.onChangets = ''
      this.onChangeht = ''
      this.queryList()
    },
    onChanget (value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
      console.log(this.query.startTime, '开始', this.query.endTime, '结束')
    },
    handleOk (e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.addOrUpdateUrl, { ...this.addOrUpdateForm })
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.fileNamesimg = []
                this.fileNamestex = []
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    // 缩略图
    clicimg (i) {
      this.pumpUrlg = i
      this.visibles = true
    },
    handleCancelhlg () {
      this.visibles = false
    },
    // 地图
    addAddres () {
      this.mapVisibles = true
      if (this.detail.locationInformation) {
        var pointData = this.detail.locationInformation.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    uploadFile (item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile (url) {
      const index = this.fileNamestex.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.fileNamestex.splice(index, 1)
      const indexTwo = this.addOrUpdateForm.fileNames.findIndex((item) => {
        return item == url
      })
      this.addOrUpdateForm.fileNames.splice(indexTwo, 1)
    },
    addAddress () {
      this.mapVisible = true
      if (this.addOrUpdateForm.locationInformation) {
        var pointData = this.addOrUpdateForm.locationInformation.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk (data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.locationInformation = data.point
      console.log(this.addOrUpdateForm.address)
    },
    isAssetTypeAnImage (ext) {
      return (
        ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
      )
    },
    // 详情
    details (id) {
      this.visible = true
      this.currentId = id
      const that = this
      this.$http
        .get(`${this.queryOneUrl}/${this.currentId}`)
        .then((res) => {
          this.detail = res.data
          if (res.data.fileNames.length !== 0) {
            for (var i = 0; i < res.data.fileNames.length; i++) {
              var index = res.data.fileNames[i].url.lastIndexOf('.')
              var ext = res.data.fileNames[i].url.substr(index + 1)
              if (that.isAssetTypeAnImage(ext) === true) {
                this.fileNamesimg.push(res.data.fileNames[i])
                console.log(this.fileNamesimg)
              } else {
                this.fileNamestex.push(res.data.fileNames[i])
              }
            }
          }
        })
        .catch(() => { })
    },
    // 关闭详情
    handleCancelh () {
      this.fileNamesimg = []
      this.fileNamestex = []
      this.visible = false
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        this.addOrUpdateForm.fileNames = []
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              data.eventTypes = data.eventType.indexOf(',') ? data.eventType.split(',') : data.eventType
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              console.log(this.addOrUpdateForm)
            })
            .catch(() => { })
        }
      })
    },
    editHandle (id) {
      this.$refs.EditModal.edit()
    },
    goDetails (record) {
      this.$refs.DetailModal.edit(record)
    },
    PublishTask () {
      if (this.selectedRows.length === 1) {
        this.$refs.TaskModal.edit(this.selectedRowsList[0])
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要发布任务的事件')
      } else {
        return this.$message.warn('只能选择一条要发布任务的事件')
      }
    },
    DispatchOrder () {
      if (this.selectedRows.length == 1) {
        this.$refs.OrderModal.edit(this.selectedRowsList[0])
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要派发工单的事件')
      } else {
        return this.$message.warn('只能选择一条要派发工单的事件')
      }
    },

    getManagerList () {
      const params = {
        dictCode: 'EVENT_TYPE'
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        
        this.ManagerList = data
      })
    },
    EndOnChange (date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange (date, dateString) {
      this.query.startTime = dateString
    },
    onChangeRadio (e) {
      this.addOrUpdateForm.stateType = e.target.value
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel () {
      this.fileNamesimg = []
      this.fileNamestex = []

      this.addOrUpdateVisible = false
    },
    onChange (value, dateString) {
      this.addOrUpdateForm.reportTime = dateString
    },
    onOk (value) { },
    customRequest (data) {
      console.log(data.file)
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.importLoading = true
      const that = this
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            // this.addOrUpdateForm.accessorys.push(response.data.url)
            const obj = {
              url: response.data.url,
              name: response.data.fileName
            }
            if (this.addOrUpdateForm.fileNames.length == 5) {
              this.$message.error('最多上传5个文件')
            } else {
              this.addOrUpdateForm.fileNames.push(obj)
              var index = obj.url.lastIndexOf('.')
              var ext = obj.url.substr(index + 1)
              if (that.isAssetTypeAnImage(ext) === true) {
                this.fileNamesimg.push(obj)
                console.log(this.fileNamesimg, 'gggg')
              } else {
                this.fileNamestex.push(obj)
                console.log(this.fileNamestex, 'gggg')
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.fileDiv {
  ul {
    list-style: 0;
    padding: 0;
    margin-left: 0;
  }
}
.fileLi {
  display: flex;
  align-items: center;
  // padding:0 10px;
  margin-top: 5px;
  justify-content: space-between;
  border-radius: 5px;
  .uploadDiv {
    cursor: pointer;
  }
}
.fileLi:hover {
  background: rgb(230, 247, 255);
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
